import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { EntityModalsService } from 'src/app/features/entity/services/entity-modals.service';
import { Entity } from 'src/app/models/entities.model';
import { FormBaseComponent } from '../../models/form-base-component';
import { FormFieldService } from '../../services/form-field.service';
import { FormEntityField } from './form-entity.model';


@Component({
  selector: 'gio-form-entity',
  templateUrl: './form-entity.component.html',
  styleUrls: ['./form-entity.component.scss'],
  host: {
    '[class]': 'classNames'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormEntityComponent extends FormBaseComponent<FormEntityField> {
  @HostBinding('style')
  get myStyle() { return this.getHostStyles(); }

  entityControl = new FormControl('');

  entity: Entity;
  selectedName: string;

  constructor(
    cd: ChangeDetectorRef,
    public _service: FormFieldService,
    private sSearchEntity: EntityModalsService,
    sanitizer: DomSanitizer
  ) { super(cd, _service, sanitizer); }

  onComponentInit() {
    this.subscribe = this.entityControl.valueChanges.subscribe(value => {
      if (this.entity) {
        if (this.entity.name !== value) {
          this.entity = null;
          this.setFieldValue(null);
        }
      }
    });

    if (this.field.value) {
      this.setEntity(this.field.value);
    }
  }

  onComponentDestroy() { }

  selectOnFocus($event: FocusEvent) {
    const inp: HTMLInputElement = $event.target as HTMLInputElement;
    inp.select();
  }

  setFieldValue(id: number) {
    const patcher = {};
    patcher[this.field.name] = id;
    if (this.field.entityFieldName) {
      patcher[this.field.entityFieldName] = this.entity;
    }

    this.group.patchValue(patcher);
  }

  async searchEntity() {
    const textValue = this.entityControl.value;
    const result = await this.sSearchEntity.getEntity({
      availableTypes: this.field.entityTypes,
      autoSearch: textValue
    });

    if (result && result.selected) {
      this.setEntity(result.selected);
    } else {
      this.setEntity(null);
    }
  }

  setEntity(entity: Entity) {
    this.entity = entity;
    this.entityControl.setValue(entity ? this.entity.name : null, { emitEvent: false });
    this.setFieldValue(entity ? entity.id : null);
    this.selectedName = '';
    if (this.entity) {
      this.selectedName = `${entity.name} (${Entity.getEntityTypeName(this.entity.source_name)})`;
    }
    this.service.detectChanges$.next();
  }

  keyPress(event: KeyboardEvent) {
    const textValue: string = this.entityControl.value;
    if (textValue && textValue.length >= 3) {
      this.searchEntity();
    }

  }

}
